import type React from "react";

type AdminPageHeaderProps = {
	title: string;
	description: string;
	actions?: React.ReactNode;
};

export default function AdminPageHeader({
	title,
	description,
	actions,
}: AdminPageHeaderProps) {
	return (
		<section className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
			<div className="space-y-1">
				<h1 className="font-clash text-4xl font-medium text-text-default tracking-tight">
					{title}
				</h1>
				<p className="text-base text-text-secondary">{description}</p>
			</div>
			{actions ? (
				<div className="flex items-center gap-2 shrink-0">{actions}</div>
			) : null}
		</section>
	);
}
